// extracted by mini-css-extract-plugin
export default {"link":"basket-link_link__fHndv","text":"basket-link_text__GSmMN"};